<template>
  <div
    class="shop-readmore"
    :class="{
      'shop-readmore--expanded': expanded,
      'shop-readmore--inactive': !active,
      'shop-readmore--initialized': initialized,
    }"
    :style="{ '--limit': limit }"
  >
    <div class="shop-readmore__content" ref="content">
      <slot><span v-html="value"></span></slot>
    </div>
    <button v-if="active" class="shop-readmore__trigger" type="button" @click="onClick">
      {{ expanded ? labels.less : labels.more }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    labels: {
      type: Object,
      default: function () {
        return { more: this.$t('readMore'), less: this.$t('showLess') }
      },
    },
    value: String,
    limit: {
      type: Number,
      default: 3,
    },
    lineheight: {
      type: Number,
      default: 22,
    },
  },
  watch: {
    value: 'init',
  },
  data() {
    return {
      expanded: false,
      active: false,
      initialized: false,
    }
  },
  methods: {
    init() {
      this.initialized = false
      this.$nextTick(() => {
        this.active = this.$refs.content.clientHeight > this.limit * this.lineheight
        this.initialized = true
      })
    },
    onClick() {
      if (!this.active) return
      this.expanded = !this.expanded
    },
  },
  mounted() {
    this.init()
  },
}
</script>

<style lang="scss">
.shop-readmore {
  &:not(.shop-readmore--inactive):not(.shop-readmore--expanded) {
    .shop-readmore__content {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: var(--limit);
      -webkit-box-orient: vertical;
      position: relative;
    }
  }

  &:not(.shop-readmore--initialized) {
    h2 {
      display: none;
    }
  }

  &__content {
    p:first-child {
      margin-top: 0;
    }
    p:last-child {
      margin-bottom: 0;
    }
  }

  &__trigger {
    cursor: pointer;

    margin-top: 0.5rem;
    text-decoration: underline;
    line-height: 1;
  }
}
</style>
